import React, {useState, useRef, useEffect} from 'react';
import '../../App.css';
import hiIcon from '../../assets/icons/hi.svg'; // 在文件顶部引入
import { sendMessageToApp } from '../../utils/nativeBridge';

const Greeting = () => {
  const [bShowEmail, setShowEmail] = useState(false);
  // 处理 "Email Us" 按钮点击事件
  const handleEmailUsClick = () => {
    //alert('Email Us...');
    sendMessageToApp('email us');
  };

  useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const version = queryParams.get("version");
      console.log("version" + version);
      if(version !=='' && version !==null){
        setShowEmail(true);
      }
      
    }, []); // 空数组表示只在组件挂载时运行一次

  return (
    <div className="chat-widget">
     {bShowEmail && 
     (
      <button onClick={handleEmailUsClick} className="chat-button">
          <img
            src={require('../../assets/icons/email.svg').default}
            alt="Email Icon"
            className="button-icon"
          />
          <span className="button-text">Email Us</span>
          
          <img
            src={require('../../assets/icons/EmailBig.svg').default}
            alt="Email Icon"
            className="button-icon-2"
          />
      </button>
      ) 
           
    }
      

      <div className="chat-header">
        <img
          src={hiIcon}
          alt="Chat Icon"
          className="chat-icon"
        />
        <div className="chat-header-text">
          <div style={{ fontWeight: '700' }}>Hi there! I'm Elle.</div>
          <div style={{ fontWeight: '700' }}>How can I help you today?</div>
        </div>
      </div>          
    </div>
  );
};

export default Greeting;
